/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Ad_TitleInputs */

const en_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Ads`)
};

const ar_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة الإعلانات`)
};

const de_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigen entfernen`)
};

const es_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina los anuncios`)
};

const fr_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les publicités`)
};

const it_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi annunci`)
};

const ja_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告の削除`)
};

const ko_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`광고 제거`)
};

const pt_br_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remoção de anúncios`)
};

const ru_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление рекламы`)
};

const th_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบโฆษณา`)
};

const tr_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reklamları Kaldır`)
};

const zh_cn_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去除广告`)
};

const zh_tw_subscription_service_level_compare_ad_title = /** @type {(inputs: Subscription_Service_Level_Compare_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去除廣告`)
};

/**
* | output |
* | --- |
* | "Remove Ads" |
*
* @param {Subscription_Service_Level_Compare_Ad_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_ad_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Ad_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Ad_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_ad_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_ad_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_ad_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_ad_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_ad_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_ad_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_ad_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_ad_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_ad_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_ad_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_ad_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_ad_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_ad_title(inputs)
	return zh_tw_subscription_service_level_compare_ad_title(inputs)
});